import React, { useState, useEffect, useRef } from 'react';
import { StyleSheet, View, ScrollView, Text, Platform, TouchableOpacity } from 'react-native';
import { useForm, Controller } from 'react-hook-form';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import TextField from '../controls/TextBox';
import NumberField from '../controls/NumberField';
import DatePickerHookControl from '../controls/DatePicker_HookControl';
import ButtonControl from '../controls/Button';
import { createItem, updateItem, getAppConfig, getPackageStatus, proceedToCreate, getInputCheckConfig } from '../service/dataOperations';
import { useAuth } from '../../../../providers/AuthProvider';
import { useClient } from '../../../../providers/ClientProvider';
import NotificationBanner, { NotificationType } from '../controls/NotificationBanner';
import formCustomStyles from './formStyles';
import * as FileSystem from 'expo-file-system';
import * as Permissions from 'expo-permissions';
import DocPicker from '../controls/DocPicker';
import { IconButton, MD3Colors, Portal, Tooltip } from 'react-native-paper';
import { ConfirmTop } from '../../../Common/ConfirmBoxTop';
import ReactDropdownSingleSelect from '../controls/Dropdown-Single';
import QuantityField from '../controls/QuantityField';
import { set } from 'date-fns';
import AttachmentViewerModal from '../../LogControllers/AttachmentViewerModal';
import { Loader } from '../../../Common/Loader';

interface PaperFormProps {
  formMode: string;
  fields: Array<any>;
  selectedRow: Array<any>;
  closeForm: () => void;
  siteId: string;
  logTitle: string;
  updateFormState: () => void;
  ItemCreated: (Item: Array<any>) => void;
  packageId?: string;
  packageStatusItems?: any;
}

const WasteTrackingForm: React.FC<PaperFormProps> = (props) => {
  const [WasteconversionFactor, setWasteconversionFactor] = useState(undefined);
  const [uniqueWasteCategories, setUniqueWasteCategories] = useState(undefined);
  const [wasteTypes, setWasteTypes] = useState(undefined);
  const [wasteCategory, setWasteCategory] = useState(null);
  const [wasteType, setWasteType] = useState(null);
  const [quantityM3, setQuantityM3] = useState(0);
  const [conversionFactor, setConversionFactor] = useState<number>();
  //let uniqueWasteCategories:any = undefined;
  const { getAccessToken } = useAuth();
  const { clientAPIURL } = useClient();

  const [formStyle, setFormStyle] = useState(styles.formContainerMobile);
  const [formMode, setFormMode] = useState(props.formMode);
  const [QuantityTonne, setQuantityTonne] = useState(0);
  const [fields, setFields] = useState(props.fields);
  const [loadForm, setLoadForm] = useState<boolean>(false);
  const [itemId, setItemId] = useState(null);
  const [d, setD] = useState<any>('');

  const [docWarning, setDocWarning] = useState<boolean>(null);
  const [warningText, setWarningText] = useState<string>(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileLoad, setFileLoad] = useState<boolean>(false);
  const [fileType, setFileType] = useState<string>();
  const [visible, setVisible] = React.useState(false);
  const [fileApi, setFileApi] = useState(null);
  const [downloadedFileUri, setDownloadedFileUri] = useState(null);
  const [docType, setDocType] = useState(null);
  const [isViewerVisible, setIsViewerVisible] = useState<boolean>(false);
  const [viewerBlob, setViewerBlob] = useState<Blob | null>(null);
  const [viewerFileName, setViewerFileName] = useState<string>("");
  const [viewerLoading, setViewerLoading] = useState<boolean>(false);
  const [savedFormData, setSavedFormData] = useState(undefined);
  const [quantityWarningAck, setQuantityWarningAck] = useState<boolean>(false);
  const [logVerificationConfig, setLogVerificationConfig] = useState<any>(undefined);

  const logLimit = logVerificationConfig?.[props.logTitle] || logVerificationConfig?.Default;
  const activeThreshold = logLimit?.Threshold || 1000;
  const activeUnitField = logLimit?.Unit || "Quantitym3"; // Dynamic field name from API
  const warningMessage = logLimit?.WarningMessage || logVerificationConfig?.WarningMessage || `This value seems unusually high for ${props.logTitle}. Please verify.`;

  //const [packageStatusItems, setPackageStatusItems] = useState(packageStatusItems || undefined);
  const { setValue, handleSubmit, control, watch, reset, resetField, setError, clearErrors, formState: { errors } } = useForm();



  let item: any;
  //let fields = props.fields;
  let formFields = props.fields;
  useEffect(() => {
    const fetchData = async () => {
      if ((formMode === 'Edit' || formMode === 'View') && props.selectedRow.length === 0) return;
      setLoadForm(false);
      try {
        const accessToken = await getAccessToken();
        //const _packageStatusItems = props.packageId && await getPackageStatus(accessToken, clientAPIURL, props.packageId);
        //setPackageStatusItems(_packageStatusItems);
        const Factor = await getAppConfig(accessToken, clientAPIURL, "wasteconversionfactors");
        console.log(Factor);
        setWasteconversionFactor(Factor);
        setUniqueWasteCategories(Factor && [...new Set(Factor.map((item: any) => item.wasteCategory))].join('#;#'));

        const inputChecks = await getInputCheckConfig(accessToken, clientAPIURL, props.packageId);
        setLogVerificationConfig(inputChecks);

        if (formMode === 'Edit' || formMode === 'View') {

          item = props.selectedRow[0] && props.selectedRow[0];
          formFields = item && props.fields.map((field) => {
            const defaultValue = item[field.key] && item[field.key];
            return { ...field, defaultValue };
          });
          item && setQuantityM3(item["Quantitym3"])
          item && setQuantityTonne(item["QuantityTonne"])
          item && setWasteCategory(item["WasteCategory"])
          item && setWasteType(item["WasteType"])

          const wasteTypes = item && item["WasteCategory"] && Factor && Factor.filter((i: any) => i.wasteCategory === item["WasteCategory"]).map((j: any) => j.wasteType).join('#;#');
          setWasteTypes(wasteTypes && wasteTypes);

          const cF: number = Factor && Factor.find(
            (item: any) => item.WasteCategory === item["WasteCategory"] && item.WasteType === item["WasteType"])?.conversionFactor;
          setConversionFactor(cF && cF);

          const savedData = Object.fromEntries(
            fields && fields
              .filter((field) => !field.hidden)
              .map((field) => {
                if (field.key === "Date" && item?.[field.key]) {
                  const [day, month, year] = item[field.key].split("/");
                  const dateObj = new Date(`${year}-${month}-${day}`);
                  return [field.key, dateObj];
                }
                return [field.key, item?.[field.key] || ""];
              })
          );
          savedData && setSavedFormData(savedData);
          const AttachmentColumn = formFields && formFields.find((c) => c.subType === "attachment");
          if (AttachmentColumn && AttachmentColumn.defaultValue) {
            setUploadedFiles(JSON.parse(AttachmentColumn.defaultValue));
          }
          item?.ID && setFileApi(encodeURI(clientAPIURL + "api/sites/" + props.siteId + "/lists/" + props.logTitle + "/items/" + item.ID + "/attachments/"));
          formFields && setFields(formFields);
          setLoadForm(true);
          item?.ID && setItemId(item.ID);

          if (savedData) {
            reset(savedData);
          }
        }
        else if (formMode === 'New') { setLoadForm(true) }


      } catch (error) {
        console.error("Error fetching waste conversion factors:", error);
      }
    };
    fetchData();
  }, [formMode, props.selectedRow]);

  const isProgrammaticUpdate = useRef(false);
  useEffect(() => {
    if (formMode !== "New") return; // only for new form

    fields.forEach((f) => {
      if (f.subType === "choice" && f.options) {
        const optionsArray = f.options.split("#;#").map((o: string) => o.trim());

        if (optionsArray.length === 1) {
          // only one choice, set it as default
          setValue(f.key, optionsArray[0]);
        }
      }
    });
  }, [fields, formMode, setValue]);

  const selectedDate = watch("Date");
  useEffect(() => {
    if (!isProgrammaticUpdate.current) {
      if (selectedDate) {
        const allow = proceedToCreate(selectedDate, props.packageStatusItems);
        if (!allow) {
          setValue("Date", null);
          setError("Date", { type: "manual", message: "Adding / Editing for this period is locked." });
          isProgrammaticUpdate.current = true;
          //setToastText("Invalid Date: The selected date is outside the package active period.");
          //setToastVisibility(true);
        }
        else {
          //how to clear error that is set above?
          clearErrors("Date");
        }
      }
    }
    else {
      isProgrammaticUpdate.current = false;
    }
  }, [selectedDate]);


  const Quantitym3 = watch("Quantitym3");
  const watchQuantityTonne = watch("QuantityTonne");
  
  useEffect(() => {
    // Reset acknowledgment if the user edits the value to something else
    setQuantityWarningAck(false);
  }, [Quantitym3, watchQuantityTonne]);

  const showQuantityWarning = Boolean(
    watch(activeUnitField) && 
    activeThreshold &&
    parseFloat(watch(activeUnitField)) > activeThreshold && 
    !quantityWarningAck &&
    logLimit?.AnomalyDetection !== "No" // Respect the toggle
  );

  useEffect(() => {
    if (!isProgrammaticUpdate.current) {
      if (Quantitym3 && conversionFactor && !isNaN(Quantitym3)) {
        isProgrammaticUpdate.current = true;
        setValue("QuantityTonne", returnConvertedVal(Quantitym3, conversionFactor));
      }
    }
    else {
      isProgrammaticUpdate.current = false;
    }
  }, [Quantitym3, setValue, conversionFactor]);
  useEffect(() => {
    if (!isProgrammaticUpdate.current) {
      if (watchQuantityTonne && conversionFactor && !isNaN(watchQuantityTonne)) {
        isProgrammaticUpdate.current = true;
        setValue("Quantitym3", returnReverseConvertedVal(watchQuantityTonne, conversionFactor));
      }
    }
    else {
      isProgrammaticUpdate.current = false;
    }
  }, [watchQuantityTonne, setValue, conversionFactor]);

  const _WasteType = watch("WasteType");
  const _WasteCategory = watch("WasteCategory");
  useEffect(() => {
    //reset()
    console.log(`Waste Type: ${_WasteType}`)
    if (!isProgrammaticUpdate.current) {
      setValue("Quantitym3", 0);
      setValue("QuantityTonne", 0);
    }
    //resetField("Quantitym3");
    //resetField("QuantityTonne");
  }, [_WasteType]);
  useEffect(() => {
    //reset()
    if (!isProgrammaticUpdate.current) {
      console.log(`Waste Category: ${_WasteCategory}`)
      resetField("WasteType");
      setValue("Quantitym3", 0);
      setValue("QuantityTonne", 0);
    }
    //resetField("Quantitym3");
    //resetField("QuantityTonne");
  }, [_WasteCategory]);

  useEffect(() => {
    if (savedFormData) {
      reset(savedFormData);
    }
  }, [savedFormData, reset]);

  const [toastVisibility, setToastVisibility] = useState<boolean>(false)
  const [toastText, setToastText] = useState<string>("");
  const [toastType, setToastType] = useState<NotificationType>('info');

  function MonthYear(value: Date) {
    if (value) {
      const date = new Date(value);
      const timezoneOffset = 4 * 60; // UTC +4 timezone offset in minutes
      const adjustedDate = new Date(date.getTime() + timezoneOffset * 60000);
      const month = adjustedDate.toLocaleString('en-US', { month: 'short' });
      const year = adjustedDate.getFullYear();
      return month + "-" + year;
    } else {
      return null;
    }
  }
  const onSubmit = async (d: any) => {
    setToastText("Submitting...");
    setToastType('submitting');
    setToastVisibility(true);
    const MonthANDYear = d.Date && d.Date != null ? MonthYear(d.Date) : null;
    const Month = MonthANDYear === null ? null : MonthANDYear.split('-')[0];
    const Year = MonthANDYear === null ? null : MonthANDYear.split('-')[1];
    const uploadedFilesJson = JSON.stringify(uploadedFiles);
    const data = { ...d, 'Attachments': uploadedFilesJson, Month, Year };
    //setD(JSON.stringify(data));
    let oItem = data;

    const result = Object.keys(data).filter((b) => b !== 'ID').map((key) => {
      const column = fields.find((c) => c.key === key);
      if (!column) {
        return null;
      }
      const value = data[key];
      const dataType = column.datatype.toLowerCase();
      if (dataType === 'datetimes') {
        delete oItem.key;
        oItem = { ...oItem, key: value };
      }

      //const sanitize = (val: any) =>
      //typeof val === 'string' ? val.replace(/<[^>]*>?/gm, '') : val;

      const formattedValue =
        dataType === 'strings'
          ? value
          : dataType === 'numbers'
            ? Number(value)
            : dataType === 'datetimes'
              ? value
              : null;

      return {
        column_Name: column.key,
        [`${dataType}_Value`]: formattedValue,
        dataype: dataType,
      };
    }).filter((x) => x !== null);

    let response: any;
    try {
      if (formMode === 'Edit') {

        const accessToken: any = await getAccessToken();
        response = await updateItem(props.logTitle, accessToken, clientAPIURL, props.siteId, itemId, result);

      } else {
        const accessToken: any = await getAccessToken();
        response = await createItem(props.logTitle, accessToken, clientAPIURL, props.siteId, result);
      }
    }
    catch (err: any) {
      if (err.response?.status === 400) {
        console.error("Error updating item:", err);
        setToastText("Operation Failed: " + err.message);
        setToastType('error');
        setToastVisibility(true);
        return;
      } else {
        setToastText("Something went wrong. Please try again.");
        setToastType('error');
        setToastVisibility(true);
      }
    }

    if (!response) {
      setToastText("Operation Failed: You are not authorized to perform this action.")
      setToastType('error');
      setToastVisibility(true);
    }
    if (response) {
      if (typeof response === 'number' || response.ok === true) {
        {
          setToastText("Your changes are saved.")
          setToastType('success');
          setToastVisibility(true);
          //const dataArray = [data];
          setTimeout(function () {
            if (formMode === 'Edit') {
              //const createdItem = oItem && {...oItem, "ID": itemId, "key": itemId };
              if (oItem) {
                oItem["ID"] = itemId
                oItem["key"] = itemId
              }
              const createdItem = oItem
              props.ItemCreated(createdItem);
            }
            else {
              const createdItem = oItem //&& { ...oItem, "ID": response, "key": response };
              if (oItem) {
                oItem["ID"] = response
                oItem["key"] = response
              }
              props.ItemCreated(createdItem);
            }
          }, 2000)
        }
      }
      else if (response && response.ok === false) {
        setToastText("Operation Failed: One or more inputs contain invalid content.")
        setToastVisibility(true);
        return result
      }
    }
  };

  const onError = (errors: any) => {
    const firstErrorKey = Object.keys(errors)[0];
    const errorField = fields.find(f => f.key === firstErrorKey);
    setToastText(`Please fill in the required field: ${errorField?.title || firstErrorKey}`);
    setToastType('error');
    setToastVisibility(true);
    if (Platform.OS === 'web') {
      const errorElement = document.getElementById(`field-${firstErrorKey}`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  };

  const invalidNumber = () => {
    setToastText("Invaid Entry: Please enter valid number to numerical column.")
    setToastVisibility(true);
  }
  function returnDate(value: string) {
    console.log("value: " + value);
    if (value) {
      try {
        const date = new Date(`${value.split('/')[0]}/${value.split('/')[1]}/${value.split('/')[2]}`);
        console.log(date);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const formattedDate = `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year}`;
        console.log("formattedDate: " + formattedDate);
        return formattedDate
      }
      catch (ex) {
        return value
      }
    }
    else return value

  }
  const handleClose = () => {
    props.closeForm()
  }

  const handleToastDismiss = () => {
    setToastVisibility(false);
  };

  const onFileUploaded = (fileObj: any) => {
    let parsedFileData = JSON.parse(fileObj);
    setUploadedFiles(prevFiles => [...prevFiles, parsedFileData]);
  }

  const showModal = () => setVisible(true);
  const hideModal = () => setVisible(false);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [fileId, setFileId] = useState<any>(null);

  function confirmDelete(id: any) {
    setFileId(id)
    showConfirmationBox();
  }
  function showConfirmationBox() {
    setShowConfirmation(!showConfirmation);
  }
  function removeFile() {
    const newFiles = fileId && uploadedFiles.filter(file => file.fileId !== fileId);
    setUploadedFiles(newFiles);
    showConfirmationBox();
  }

  const downloadFile = async (url: string, token: string, fileName: string) => {

    if (Platform.OS === 'ios') {
      const { status } = await Permissions.askAsync(Permissions.MEDIA_LIBRARY);
      if (status !== 'granted') {
        alert('Sorry, we need camera roll permissions to make this work!');
      }
    } else if (Platform.OS === 'android') {
      const { status } = await Permissions.askAsync(Permissions.MEDIA_LIBRARY);
      if (status !== 'granted') {
        alert('Sorry, we need write storage permissions to make this work!');
      }
    }

    const uri = url;
    setFileType(uri.split('.').pop().toLowerCase());
    setDocType(uri.split('.').pop().toLowerCase());
    const fileUri = FileSystem.documentDirectory + fileName;
    let options = {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    };
    console.info('Trying to download ' + uri);
    console.info('Download Loc ' + fileUri);
    FileSystem.makeDirectoryAsync(FileSystem.documentDirectory, { intermediates: true })
      .then(() => {
        FileSystem.downloadAsync(uri, fileUri, options)
          .then(({ uri }) => {
            console.log('Finished downloading to ', uri);
            setDownloadedFileUri(uri);
            showModal();
            setFileLoad(false);
          })
          .catch(error => {
            console.error(error);
          });
      })
      .catch(error => {
        console.error('Error creating directory:', error);
      });
  }
  const openFile = async (fileId: string, fileName: string) => {
    const api = fileApi + encodeURIComponent(fileId);
    const accessToken = await getAccessToken();

    if (Platform.OS === "web") {
      setViewerFileName(fileName);
      setIsViewerVisible(true);
      setViewerLoading(true);
      setViewerBlob(null);
      try {
        const response = await fetch(api, {
          headers: { 'Authorization': `Bearer ${accessToken}` }
        });
        if (!response.ok) {
          throw new Error(`Failed to fetch file: ${response.statusText}`);
        }
        const blob = await response.blob();
        setViewerBlob(blob);
      } catch (err) {
        console.error('Error opening file: ', err);
        setToastText("Failed to load file for preview.");
        setToastType('error');
        setToastVisibility(true);
        setIsViewerVisible(false);
      } finally {
        setViewerLoading(false);
      }
    } else {
      setFileLoad(true);
      downloadFile(api, accessToken, fileName);
    }
  }
  const fieldStyle = formMode === "View" ? formCustomStyles.fieldContianerViewMode : formCustomStyles.fieldContianer

  const handleCategoryChange = (val: any) => {
    const wasteTypes = WasteconversionFactor && WasteconversionFactor.filter((i: any) => i.wasteCategory === val).map((j: any) => j.wasteType).join('#;#');
    setWasteTypes(wasteTypes);
    setWasteCategory(val);
    resetField("WasteDisposalMethod");
  }
  const handleTypeChange = (val: any) => {

    //console.log(val)
    setWasteType(val);

    const cF: number = WasteconversionFactor && WasteconversionFactor.find(
      (item: any) => item.wasteCategory === wasteCategory && item.wasteType === val)?.conversionFactor;
    setConversionFactor(cF);
    //console.log(cF);
    const dM: string = WasteconversionFactor && wasteCategory && val && WasteconversionFactor.find(
      (item: any) => item.wasteCategory === wasteCategory && item.wasteType === val)?.defaultDisposalMethod;
    dM && setValue("WasteDisposalMethod", dM);
  }
  const handleQuantityChange = (val: any) => {
    setQuantityM3(val);
    const convertedVal: number = (parseInt(val) * conversionFactor)
    setQuantityTonne(convertedVal);
    setFields((prevFields) =>
      prevFields.map((field) =>
        field.key === "QuantityTonne" ? { ...field, defaultValue: convertedVal }
          :
          field.key === "Quantitym3" ? { ...field, defaultValue: val }
            :
            field
      )
    );
  }
  const handleQuantityTonneChange = (val: any) => {

  }
  const returnConvertedVal = (val: number, factor: number) => {
    const convertedVal = (val * factor)
    return Number.isInteger(convertedVal) ? convertedVal.toString() : convertedVal.toFixed(2);
  }
  const returnReverseConvertedVal = (val: number, factor: number) => {
    const convertedVal = (val / factor)
    return Number.isInteger(convertedVal) ? convertedVal.toString() : convertedVal.toFixed(2);
  }
  function getMiddleEllipsis(name: string, startChars = 12, endChars = 16) {
    if (!name) return "";

    // If already short enough, return as-is
    if (name.length <= startChars + endChars + 3) return name;

    const start = name.slice(0, startChars);
    const end = name.slice(-endChars);
    return `${start}…${end}`;
  }
  return (
    loadForm === false
      ? <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 40 }}>
          <Loader />
          <Text style={{ marginTop: 12, color: '#666' }}>Retrieving waste conversion factors...</Text>
        </View>
      : uniqueWasteCategories &&
      <View style={{ flex: 1 }}>
        <Portal>
          <NotificationBanner
            visible={toastVisibility}
            message={toastText}
            type={toastType}
            onDismiss={handleToastDismiss}
            duration={3000}
          />
        </Portal>
          {/* {showConfirmation && (
                  
                    
                      <ConfirmBox title={"Confirmation"}
                        message={"Are you sure you want to proceed to delete selected items?"}
                        yesCallback={removeFile}
                        noCallback={showConfirmationBox} />
                    
                  
                )} */}
          {showConfirmation && (
            <ConfirmTop
              visible={showConfirmation}
              title="Delete Attachment"
              message="Are you sure you want to permanently delete this attachment? This action cannot be undone."
              onYes={removeFile}
              onNo={showConfirmationBox}
              yesText="Delete"
              noText="Cancel"
            />
          )}
          <ScrollView>
            <>
              <View style={[{ flex: 1, margin: 10 }, styles.buttonsContainer]}>
                  {
                  formMode === "View"
                    ?
                    <View>
                      <View style={[{ flex: 1 }, styles.buttonsContainer]}><ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' /></View>
                    </View>
                    :
                    <ScrollView horizontal>
                      <View style={styles.buttonsContainer}>
                        <View style={{}}>
                          <ButtonControl icon="content-save-edit" mode="contained" onPress={handleSubmit(onSubmit, onError)} Title='Submit' />
                        </View>
                        <View style={{}}>
                          <ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' />
                        </View>
                      </View>
                    </ScrollView>
                }
              </View>
              {/* Attachment Section Start */}
              {docWarning === true ?
                <View>
                  <Text style={{ color: 'red' }}>{warningText}</Text>
                </View>
                : null}
              {/* <View style={{ borderWidth: 2, borderColor: '#DDDDDD', paddingLeft: 10 }}> */}
              <View style={{ paddingLeft: 10 }}>
                <View style={{ flexDirection: 'column' }}>
                  {formMode === "View" ? null :
                    <View style={{ padding: 20 }}>
                      <DocPicker formMode={formMode} onFileUploaded={onFileUploaded} clientAPIURL={clientAPIURL} showWarning={setDocWarning} warningText={setWarningText} />
                    </View>
                  }
                  {docWarning === true ?
                    <View>
                      <Text style={{ color: 'red' }}>{warningText}</Text>
                    </View>
                    : null}
                </View>
                <View style={{ paddingLeft: 20 }}>

                  {uploadedFiles.map((file: { fileId: string, fileName: string }, index) => (
                    <View key={index} style={{ flexDirection: "row", alignItems: "center", height: 50, gap: 8 }}>
                      <TouchableOpacity 
                        onPress={() => openFile(file.fileId, file.fileName)} 
                        style={{ flex: 1, minWidth: 0 }}
                        disabled={formMode === "New"}
                      >
                        <Text style={{ marginRight: 10 }}>
                          {index + 1}: <Text style={{ color: formMode === "New" ? '#333' : 'blue', textDecorationLine: formMode === "New" ? 'none' : 'underline' }} numberOfLines={1}>
                            {getMiddleEllipsis(file.fileName, 14, 18)}
                          </Text>
                        </Text>
                      </TouchableOpacity>
                      
                      {formMode !== "View" && (
                        <View style={{ flexShrink: 0 }}>
                          <Tooltip title="Remove attachment">
                            <IconButton
                              icon="close-circle-outline"
                              iconColor={MD3Colors.error50}
                              size={20}
                              onPress={() => confirmDelete(file.fileId)}
                            />
                          </Tooltip>
                        </View>
                      )}
                    </View>
                  ))}

                </View>
                <View style={{ padding: 10 }}></View>
              </View>

              {/* <View style={formCustomStyles.allFieldsContainer}> */}
              <View style={{}}>
                {(fields ?? []).map((field, index) => {
                  if (field.hidden === true) {
                    return null
                  }
                  else if (field.key === "WasteCategory") {
                    return (
                      <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                        <ReactDropdownSingleSelect
                          field={field}
                          key={field.key.toString()}
                          editable={formMode === 'View' ? false : true}
                          control={control}
                          Ctrl={Controller}
                          errors={errors}
                          changeEvent={handleCategoryChange}
                          choices={uniqueWasteCategories}
                        />
                      </View>
                    );
                  }
                  else if (field.key === "WasteType") {
                    return (
                      <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                        <ReactDropdownSingleSelect
                          field={field}
                          key={field.key.toString()}
                          editable={formMode === 'View' ? false : true}
                          control={control}
                          Ctrl={Controller}
                          errors={errors}
                          changeEvent={handleTypeChange}
                          choices={wasteTypes}
                        />
                      </View>
                    );
                  }
                  else if (field.key === "Quantitym3") {
                    return (
                      <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                        <QuantityField
                          key={field.key.toString()}
                          editable={formMode === 'View' ? false : true}
                          field={field}
                          control={control}
                          styles={styles.input}
                          Ctrl={Controller}
                          errors={errors}
                          logTitle={props.logTitle}
                          fields={fields}
                          setFields={setFields}
                          invalidNumber={invalidNumber}
                          conversionFactor={conversionFactor ? conversionFactor : undefined}
                          changeEvent={handleQuantityChange}
                          updatedValue={QuantityTonne}
                        //ref={register}
                        />
                          {showQuantityWarning && (
                            <View style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#fff3cd', padding: 8, borderRadius: 4, marginTop: 4 }}>
                              <MaterialCommunityIcons name="alert-circle-outline" size={16} color="#856404" />
                              <Text style={{ color: '#856404', fontSize: 12, marginLeft: 6, flex: 1 }}>
                                {warningMessage}
                              </Text>
                              <TouchableOpacity onPress={() => setQuantityWarningAck(true)}>
                                <Text style={{ color: '#856404', fontSize: 12, fontWeight: 'bold', padding: 4 }}>OK</Text>
                              </TouchableOpacity>
                            </View>
                          )}
                        </View>
                    );
                  }
                  else if (field.key === "QuantityTonne") {
                    return (
                      <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                        <QuantityField
                          key={field.key.toString()}
                          editable={formMode === 'View' ? false : true}
                          field={field}
                          control={control}
                          styles={styles.input}
                          Ctrl={Controller}
                          errors={errors}
                          logTitle={props.logTitle}
                          fields={fields}
                          setFields={setFields}
                          invalidNumber={invalidNumber}
                          conversionFactor={conversionFactor ? conversionFactor : undefined}
                          changeEvent={handleQuantityTonneChange}
                          updatedValue={QuantityTonne}
                        //ref={register}
                        />
                          {showQuantityWarning && (
                            <View style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#fff3cd', padding: 8, borderRadius: 4, marginTop: 4 }}>
                              <MaterialCommunityIcons name="alert-circle-outline" size={16} color="#856404" />
                              <Text style={{ color: '#856404', fontSize: 12, marginLeft: 6, flex: 1 }}>
                                This quantity seems unusually high. Please verify that it is correct.
                              </Text>
                              <TouchableOpacity onPress={() => setQuantityWarningAck(true)}>
                                <Text style={{ color: '#856404', fontSize: 12, fontWeight: 'bold', padding: 4 }}>OK</Text>
                              </TouchableOpacity>
                            </View>
                          )}
                        </View>
                    );
                  }
                  else {

                    switch (field.subType) {
                      case 'text':
                        return (
                          // <Text>{field.key}</Text>
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                            <TextField
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              field={field}
                              control={control}
                              styles={styles.input}
                              Ctrl={Controller}
                              errors={errors}
                            //ref={register}
                            />
                          </View>
                        );
                      case 'choice':
                        return (
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                            <ReactDropdownSingleSelect
                              field={field}
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              control={control}
                              Ctrl={Controller}
                              errors={errors}
                            />
                          </View>
                        );
                      case 'float':
                        return (
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                            <NumberField
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              field={field}
                              control={control}
                              styles={styles.input}
                              Ctrl={Controller}
                              errors={errors}
                              logTitle={props.logTitle}
                              fields={fields}
                              setFields={setFields}
                              invalidNumber={invalidNumber}
                            //ref={register}
                            /></View>
                        );
                      case 'integer':
                        return (
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                            <NumberField
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              field={field}
                              control={control}
                              styles={styles.input}
                              Ctrl={Controller}
                              errors={errors}
                              logTitle={props.logTitle}
                              fields={fields}
                              setFields={setFields}
                              invalidNumber={invalidNumber}
                            //ref={register}
                            /></View>
                        );
                      case 'date':
                        return (
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle, { zIndex: 1 }]}>
                            <DatePickerHookControl
                              key={field.key.toString()}
                              field={field}
                              editable={formMode === 'View' ? false : true}
                              control={control}
                              styles={styles.date}
                              Ctrl={Controller}
                              errors={errors}
                            //ref={register}
                            /></View>
                        );
                      default:
                        return null
                    }
                  }
                }
                )}
              </View>
              <View style={{ margin: 10 }}>
                {
                  formMode === "View"
                    ?
                    <View style={[{ flex: 1 }, styles.buttonsContainer]}><ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' /></View>
                    :
                    <ScrollView horizontal style={{ width: '100%' }}>
                      <View style={styles.buttonsContainer}>
                        <View style={{}}><ButtonControl icon="content-save-edit" mode="contained" onPress={handleSubmit(onSubmit, onError)} Title='Submit' /></View>
                        <View style={{}}><ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' /></View>
                      </View>
                    </ScrollView>
                }
              </View>


            </>
          </ScrollView>
        <AttachmentViewerModal
          visible={isViewerVisible}
          onClose={() => setIsViewerVisible(false)}
          fileName={viewerFileName}
          blob={viewerBlob}
          loading={viewerLoading}
        />
      </View>
  );
};

const styles = StyleSheet.create({
  container: {
    //justifyContent: 'center',
    //alignItems: 'center',
    paddingLeft: '5%',
    paddingRight: '5%',

    flex: 1,
    padding: 16,
    gap: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  toastOverlay: {
    position: 'absolute',
    bottom: 20,      // stick 20px above bottom of screen
    left: 0,
    right: 0,
    alignItems: 'center', // center the toast
    zIndex: 9999,    // make sure it appears above everything
  },
  formContainerPC: {
    paddingLeft: '25%',
    paddingRight: '25%',
  },
  formContainerMobile: {
    borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)
    backgroundColor: '#FFFFFF',
    shadowColor: 'blue', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4,
    //marginLeft: '5%',
    //marginRight: '5%',
    //paddingLeft: '2%',
    //paddingRight: '2%',
  },
  input: {
    backgroundColor: 'transparent',
    marginVertical: 5,
    marginBottom: 30,
    borderWidth: 1,
    //borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)
    shadowColor: 'blue', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4,
    minHeight: 60,
    //maxHeight: 60,
  },
  date: {
    minWidth: '100%',
    minHeight: 60,
    maxHeight: 60,

    backgroundColor: 'transparent',
    marginVertical: 5,
    marginBottom: 30,
    borderWidth: 1,
    //borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)
    shadowColor: 'blue', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4
  },
  buttonsContainer: {
    flex: 1,
    //padding: 16,
    gap: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    //alignItems: 'center',
    //justifyContent: 'space-evenly',
    height: 60
  }
});

export default WasteTrackingForm;
